<template>
    <v-container fluid>
        <!-- Generate report button -->
        <v-layout row justify-end fill-height>
            <v-flex xs3 sm3 md2 class="admin_dl_button_flex"> 
                <v-btn v-if="report_button" class="success admin_dl_button">
                    <v-icon left>cloud_download</v-icon>
                    <download-csv
                        :data="csvReportData"
                        :fields="getReportFields"
                        :labels="report_labels"
                        :name="report_name"
                    >
                        Download As CSV
                    </download-csv>
                </v-btn>
            </v-flex>
        </v-layout>
        <br>
        <!-- Data table -->
        <v-layout row fill-height> 
            <v-flex>
                <SortableDataTable
                    ref="advert-vuetable"
                    :header-fields="obtainTableFields()"
                    :data="sortedData || []"
                    :totals-row="totalsRow"
                    :sort-field="currentSortField"
                    :sort="currentSortDir"
                    @on-update="updateSort"
                    not-found-msg="No data available"
                >
                </SortableDataTable>
            </v-flex>
        </v-layout>
        <v-layout 
            row 
            justify-end 
            fill-height
            v-if="this.rows.length > 20"
        >
            <v-flex xs3 sm3 md2 lg2 class="admin_dl_button_flex"> 
                <v-btn v-if="report_button" class="success admin_dl_button">
                    <v-icon left>cloud_download</v-icon>
                    <download-csv
                        :data="csvReportData"
                        :fields="getReportFields"
                        :labels="report_labels"
                        :name="report_name"
                    >
                        Download As CSV
                    </download-csv>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-fab-transition>
            <v-btn
                md-3 mr-5
                dark
                fab
                fixed
                right
                bottom
                color="purple"
                @click="toTop"
                v-if="this.rows.length > 20"
            >
                <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-container>

</template>

<script>
import { mapGetters } from 'vuex'
import SortableDataTable from './SortableDataTable.vue';

export default {
    name: 'AdminDataTable',
    components: {
        SortableDataTable
    },
    props: {
        rows: { type: Array, required: true },
        dateFrom: { type: String, required: true },
        dateTo: { type: String, required: true },
        groupByMonth: { type: Boolean, required: false }
    },
    data() {
        return {
            report_button: false,
            css: {
                table: {
                    tableWrapper: '',
                    tableHeaderClass: 'thead fixed',
                    tableBodyClass: 'vuetable-semantic-no-top fixed',
                    tableClass: 'ui selectable unstackable celled table is-striped',
                    loadingClass: 'loading',
                    ascendingIcon: 'grey chevron up icon',
                    descendingIcon: 'grey chevron down icon',
                    ascendingClass: 'sorted-asc',
                    descendingClass: 'sorted-desc',
                    sortableIcon: 'grey sort icon',
                    handleIcon: 'grey sidebar icon',
                },
            },
            default_fields: [
                {
                    name:'date',
                    label:'Date',
                    visible: true,
                    sortable: true
                },
                {
                    name:'month_name',
                    label:'Month',
                    visible: false,
                    sortable: true,
                    defaultSorting: 'desc'
                },
                {
                    name:'platform_name',
                    label:'Platform',
                    visible: true,
                    sortable: true,
                    defaultSorting: 'asc'
                },
                {
                    name:'advertiser_name',
                    label:'Advertiser',
                    visible: true,
                    sortable: true,
                    defaultSorting: 'asc'
                },
                {
                    name:'campaign_name',
                    label:'Campaign',
                    visible: true,
                    sortable: true,
                    defaultSorting: 'asc'
                },
                {
                    name:'os_name',
                    label:'OS',
                    visible: true,
                    sortable: true,
                    defaultSorting: 'asc'
                },
                {
                    name:'impressions',
                    label:'Impressions',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'clicks',
                    label:'Clicks',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'conversions',
                    label:'Conversions',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'media_cost',
                    label:'Media Cost ($)',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'advertiser_spent',
                    label:'Advertiser Spend ($)',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'transaction_value',
                    label:'Transaction Value ($)',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'profit',
                    label:'Profit ($)',
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    sortable: true
                },
                {
                    name:'margin',
                    label:'Margin (%)',
                    sortable: true
                },
                {
                    name:'ecpa',
                    label:'eCPA ($)',
                    sortable: true
                },
                {
                    name:'roi',
                    label:'ROI (%)',
                    sortable: true
                },
            ],
            report_name: "DataReport_" + new Date().toISOString().substr(0, 10) + ".csv",
            report_labels: {
                impressions: 'Impressions',
                clicks: 'Clicks',
                conversions: 'Conversions',
                media_cost: 'Media Cost ($)',
                advertiser_spent: 'Advertiser Spend ($)',
                transaction_value: 'Transaction Value ($)',
                profit: 'Profit ($)',
                margin: 'Margin (%)',
                ecpa: 'eCPA ($)',
                roi: 'ROI (%)',
                date: 'Date',
                month_name: 'Month',
                campaign_name: 'Campaign Name',
                campaign_id: 'Campaign ID',
                advertiser_name: 'Advertiser Name',
                advertiser_id: 'Advertiser ID',
                platform_name: 'Platform Name',
                platform_id: 'Platform ID',
                os_name: 'OS',
                os_id: 'OS ID',
            },
            report_default_fields: [
                "impressions", "clicks", "conversions", "media_cost", 
                "advertiser_spent", "transaction_value", "profit", "margin", "ecpa", "roi"
            ],
            totalsRow: {},
            currentSortDir: 'desc',
            currentSortField: 'date',
            os_mappings: {
                '11': 'iOS',
                '10': 'Android',
                '12': 'Other'
            },
            months_mappings: {
                '1': 'January',
                '2': "February", 
                '3': "March", 
                '4': "April", 
                '5': "May", 
                '6': "June",
                '7': "July", 
                '8': "August", 
                '9': "September", 
                '10': "October", 
                '11': "November", 
                '12': "December"
            },
            months_array: ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"]
        }
    },
    computed: {
        ...mapGetters([
            'mappedPlatforms',
            'mappedAdvertisers',
            'mappedCampaigns',
        ]),
        // backend API data transformed and filtered by selected input values and group by switches
        processedData() {
            if (this.rows.length >0) {
                this.report_button = true
                let mapped_platforms = this.mappedPlatforms
                let mapped_adverts = this.mappedAdvertisers
                let mapped_campaigns = this.mappedCampaigns
                let mapped_os = this.os_mappings
                let rows_copy = JSON.parse(JSON.stringify(this.rows))

                let out_rows = rows_copy.map(obj => {
                    if (!obj.conversions) {
                        obj.conversions = 0
                    }
                    if (!obj.clicks) {
                        obj.clicks = 0
                    }
                    if (!obj.impressions) {
                        obj.impressions = 0
                    }
                    if (!obj.media_cost) {
                        obj.media_cost = 0
                    }
                    if (!obj.advertiser_spent) {
                        obj.advertiser_spent = 0
                    }
                    if (!obj.transaction_value) {
                        obj.transaction_value = 0
                    } else {
                        obj.transaction_value = Number(obj.transaction_value).toFixed(2)
                    }

                    obj.profit = Number(obj.advertiser_spent - obj.media_cost).toFixed(2).toString()
                    if (obj.profit === "-0.0") {
                        obj.profit = "0.00"
                    }
                    if (obj.advertiser_spent != 0) {
                        obj.margin = Number((obj.profit / obj.advertiser_spent)*100).toFixed(1)
                    } else {
                        obj.margin = '0.0'
                    }
                    
                    if (obj.conversions != 0) {
                        obj.ecpa = Number(obj.advertiser_spent / obj.conversions).toFixed(2)
                    } else {
                        obj.ecpa = '0.00'
                    }
                    obj.media_cost = Number(obj.media_cost).toFixed(2)
                    obj.advertiser_spent = Number(obj.advertiser_spent).toFixed(2)
                    
                    if (obj["_col0"]) {
                        obj.month_name = this.months_mappings[obj["_col0"]]
                        obj.month_timestamp = this.mapMonthNumberToTimestamp[obj["_col0"]].timestamp
                        // TODO: also determine year and update sortedData computed logic
                    }

                    if (obj.platform_id) {
                        obj.platform_name = mapped_platforms[obj.platform_id] ? mapped_platforms[obj.platform_id] : `N/A (id: ${obj.platform_id})`
                    } else {
                        obj.platform_name = ""
                    }
                    if (obj.advertiser_id) {
                        obj.advertiser_name = mapped_adverts[obj.advertiser_id] ? mapped_adverts[obj.advertiser_id] : `N/A (id: ${obj.advertiser_id})`
                    } else {
                        obj.advertiser_name = ""
                    }
                    if (obj.campaign_id) {
                        obj.campaign_name = mapped_campaigns[obj.campaign_id] ?  mapped_campaigns[obj.campaign_id] : `N/A (id: ${obj.campaign_id})`
                    } else {
                        obj.campaign_name = ""
                    }
                    if (obj.os_id) {
                        obj.os_name = mapped_os[obj.os_id] ? mapped_os[obj.os_id] : `N/A (id: ${obj.os_id})`
                    } else {
                        obj.os_name = ""
                    }

                    if (obj.advertiser_spent != 0) {
                        obj.roi = Number((obj.transaction_value / obj.advertiser_spent)*100).toFixed(1)
                    } else {
                        obj.roi = '0.0'
                    }
                    
                    return obj
                })

                // Sort by date, platform, advert, campaign
                let sorted_rows = out_rows.sort(
                    (a,b) => new Date(a.date).getTime() - new Date(b.date).getTime()                     
                    || a.month_timestamp - b.month_timestamp
                    || a.platform_name.localeCompare(b.platform_name)
                    || a.advertiser_name.localeCompare(b.advertiser_name)
                    || a.campaign_name.localeCompare(b.campaign_name)
                    || a.os_name.localeCompare(b.os_name)
                )

                let totals = this.summaryRow(sorted_rows)
                if (totals != {}) {
                    // sorted_rows.push(totals)
                    this.totalsRow = totals
                }

                return sorted_rows
            }
            // totals row
            return this.rows
        },
        // processed data sorted by selected filter (field, asc, desc)
        sortedData() {
            let processedDataCopy = Array.from(this.processedData)            
            return processedDataCopy.sort((a, b) => {
                let modifier = 1
                if (this.currentSortDir === 'desc') {
                    modifier = -1
                }
                if (['date', 'platform_name', 'advertiser_name', 'campaign_name', 'os_name'].includes(this.currentSortField)) {
                    if (a[this.currentSortField] < b[this.currentSortField]) {
                        return -1 * modifier
                    }
                    if (a[this.currentSortField] > b[this.currentSortField]) {
                        return modifier
                    }
                    
                } else if (this.currentSortField === 'month_name') {
                    if (a.month_timestamp < b.month_timestamp) {
                        return -1 * modifier
                    }
                    if (a.month_timestamp > b.month_timestamp) {
                        return  modifier
                    }
                } else {
                    if (Number(a[this.currentSortField]) < Number(b[this.currentSortField])) {
                        return -1 * modifier
                    }
                    if (Number(a[this.currentSortField]) > Number(b[this.currentSortField])) {
                        return modifier
                    }
                }
                return 0
            })
        },
        // data for csv report
        csvReportData() {
            let data = Array.from(this.sortedData)
            data.push(this.totalsRow)
            return data
        },
        // define which columns should be shown
        tableFields() {
            /* property to select table headers depending on the row object,
                disable excluded headers */
            if (this.rows.length >0){
                // get list of keys from the first dict
                let dummy_row = JSON.parse(JSON.stringify(this.rows[0]))
                if (dummy_row.platform_id){
                    dummy_row.platform_name = true
                }
                if (dummy_row.advertiser_id){
                    dummy_row.advertiser_name = true
                }
                if (dummy_row.campaign_id){
                    dummy_row.campaign_name = true
                }
                if (dummy_row.os_id){
                    dummy_row.os_name = true
                }
                if (dummy_row["_col0"]){
                    dummy_row.month_name = true
                }

                let row_keys = Object.keys(dummy_row)
                // console.dir(row_keys)
                let variable_fields = ['date', 'month_name', 'platform_name','advertiser_name','campaign_name','os_name']

                // fields to exclude from default fields list
                let fields_to_disable = variable_fields.filter(field => !row_keys.includes(field))
                // console.dir(fields_to_disable)

                // make excluded fields invisible
                let out_fields = this.default_fields.map(field_obj => {
                    if (fields_to_disable.includes(field_obj.name)){
                        field_obj.visible = false
                    } else {
                        field_obj.visible = true
                    }
                    return field_obj
                })
                out_fields = out_fields.filter(field_obj => field_obj.visible)
                // console.dir(out_fields)
                return out_fields
                
            } else{
                return this.default_fields
            }
        },
        getReportFields() {
            // compose headers for a CSV report
            let out_fields = [...this.report_default_fields]
            let table_fields = this.tableFields.map(field_obj => field_obj.name)
            if (table_fields.includes('os_name')){
                out_fields.unshift('os_name', 'os_id')
            }
            if (table_fields.includes('campaign_name')){
                out_fields.unshift('campaign_name', 'campaign_id')
            }
            if (table_fields.includes('advertiser_name')){
                out_fields.unshift('advertiser_name', 'advertiser_id')
            }
            if (table_fields.includes('platform_name')){
                out_fields.unshift('platform_name', 'platform_id')
            }
            if (table_fields.includes('month_name')){
                out_fields.unshift('month_name')
            }
            if (table_fields.includes('date')){
                out_fields.unshift('date')
            }
            return out_fields
        },
        mapMonthNumberToTimestamp(){
            let mappingsForMonths = {}
            let datesArray = []
            let lastMonthLastDay = new Date(this.dateTo).setDate(28)
            let firstMonthFirstDay = new Date(new Date(this.dateFrom).setDate(1))

            datesArray.push(firstMonthFirstDay)
            var currentDate = new Date(firstMonthFirstDay)

            while (currentDate < lastMonthLastDay) {
                currentDate.setDate(currentDate.getDate() + 40)
                let first_day_date = new Date(currentDate.setDate(1))
                datesArray.push(first_day_date)
            }
            datesArray.map(date_obj => {
                let month_number = Number(date_obj.getMonth()+1).toString()
                let date_dict = {
                    date_obj: date_obj,
                    timestamp: date_obj.getTime()
                }
                mappingsForMonths[month_number] = date_dict
            })

            return mappingsForMonths
        },
        showFab() {
            // return document.body.scrollTop > 5 || document.documentElement.scrollTop > 5
            return Math.max(document.documentElement.clientHeight, window.innerHeight || 0) > 800
            // return document.documentElement.scrollTop > 400
        }
    },
    methods: {
        summaryRow(data_array) {
            // sum values of passed rows, calculate data points, return as summary row dict
            if (data_array.length >0){
                let out_obj = {
                    date: "",
                    month_name: "",
                    platform_id: "",
                    platform_name: "",
                    campaign_id: "",
                    campaign_name: "",
                    advertiser_id: "",
                    advertiser_name: "",
                    os_id: "",
                    os_name: "",
                }         
                
                out_obj.clicks = data_array.reduce((total, row) => {
                    return total + Number(row.clicks)
                }, 0)
                out_obj.impressions = data_array.reduce((total, row) => {
                    return total + Number(row.impressions)
                }, 0)
                out_obj.conversions = data_array.reduce((total, row) => {
                    return total + Number(row.conversions)
                }, 0)
                out_obj.media_cost = data_array.reduce((total, row) => {
                    return total + Number(row.media_cost)
                }, 0)
                if (out_obj.media_cost != 0) {
                    out_obj.media_cost = Number(out_obj.media_cost).toFixed(2)
                }

                out_obj.advertiser_spent = data_array.reduce((total, row) => {
                    return total + Number(row.advertiser_spent)
                }, 0)
                if (out_obj.advertiser_spent != 0) {
                    out_obj.advertiser_spent = Number(out_obj.advertiser_spent).toFixed(2)
                }
                
                out_obj.profit = Number(out_obj.advertiser_spent - out_obj.media_cost).toFixed(2)
                if (out_obj.advertiser_spent != 0) {
                    out_obj.margin = Number((out_obj.profit / out_obj.advertiser_spent)*100).toFixed(1)
                } else {
                    out_obj.margin = 0                    }
                
                if (out_obj.conversions != 0) {
                    out_obj.ecpa = Number(out_obj.advertiser_spent / out_obj.conversions).toFixed(2)
                } else {
                    out_obj.ecpa = '0.00'
                }

                out_obj.transaction_value = data_array.reduce((total, row) => {
                    return total + Number(row.transaction_value)
                }, 0)
                if (out_obj.transaction_value != 0) {
                    out_obj.transaction_value = Number(out_obj.transaction_value).toFixed(2)
                }


                if (out_obj.advertiser_spent != 0) {
                    out_obj.roi = Number((out_obj.transaction_value / out_obj.advertiser_spent)*100).toFixed(1)
                } else {
                    out_obj.roi = 0
                }


                let table_fields = this.tableFields.map(field_obj => field_obj.name)
                if (table_fields.includes('date')) {
                    out_obj.date = 'Total'
                } else if (table_fields.includes('month_name')) {
                    out_obj.month_name = 'Total'
                } else if (table_fields.includes('platform_name')) {
                    out_obj.platform_name = 'Total'
                } else if (table_fields.includes('advertiser_name')) {
                    out_obj.advertiser_name = 'Total'
                } else if (table_fields.includes('campaign_name')) {
                    out_obj.campaign_name = 'Total'
                } else if (table_fields.includes('os_name')) {
                    out_obj.os_name = 'Total'
                }

                // console.dir(out_obj)
                return out_obj

            } else {
                return {}
            }
        },
        toTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        obtainTableFields() {
            return this.tableFields
        },
        updateSort({ sortField, sort }) {
            if (sortField === this.currentSortField) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            } else {
                this.currentSortDir = sort
            }
            this.currentSortField = sortField
        }, 
    },
    created(){
        if (this.groupByMonth) {
            this.currentSortField = 'month_name'
        } else {
            this.currentSortField = 'date'
        }
    },
    beforeUpdate(){
        if (this.groupByMonth) {
            this.currentSortField = 'month_name'
        } else {
            this.currentSortField = 'date'
        }
    }
}
</script>

<style>
tbody.vuetable-body > tr:last-child {
    /* background: #b9cbe8; */
    font-weight: bold;
}

.admin_dl_button_flex {
    direction:rtl;
}

.admin_dl_button {
    direction: ltr;
}
</style>
